import { useState } from "react";

import useMFAToken from "./useMFAToken";

export default function useEnrollment() {
  const [OOBCode, setOOBCode] = useState("");
  const { getAccessToken } = useMFAToken();

  const auth0URL = `https://${process.env.REACT_APP_AUTH0_ORIGINAL_DOMAIN}`;
  const enrollURL = `${auth0URL}/mfa/associate`;
  const confirmURL = `${auth0URL}/oauth/token`;

  const enrollWithSMS = async (phone_number: string) => {
    const token = await getAccessToken("enroll");

    const res = await fetch(enrollURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        authenticator_types: ["oob"],
        oob_channels: ["sms"],
        phone_number,
      }),
    });

    if (res.status === 200) {
      const { oob_code } = await res.json();
      setOOBCode(oob_code);
    }
    return res;
  };

  const confirmSMS = async (binding_code: string) => {
    const token = await getAccessToken("enroll");

    const res = await fetch(confirmURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        grant_type: "http://auth0.com/oauth/grant-type/mfa-oob",
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
        mfa_token: token,
        oob_code: OOBCode,
        binding_code,
      }),
    });

    return res;
  };

  const enrollWithVoice = async (phone_number: string) => {
    const token = await getAccessToken("enroll");

    const res = await fetch(enrollURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        authenticator_types: ["oob"],
        oob_channels: ["voice"],
        phone_number,
      }),
    });

    if (res.status === 200) {
      const { oob_code } = await res.json();
      setOOBCode(oob_code);
    }
    return res;
  };

  const confirmVoice = async (binding_code: string) => {
    const token = await getAccessToken("enroll");

    const res = await fetch(confirmURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        grant_type: "http://auth0.com/oauth/grant-type/mfa-oob",
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
        mfa_token: token,
        oob_code: OOBCode,
        binding_code,
      }),
    });

    return res;
  };

  const enrollWithOTP = async () => {
    const token = await getAccessToken("enroll");

    const res = await fetch(enrollURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ authenticator_types: ["otp"] }),
    });

    return res;
  };

  const confirmOTP = async (otp: string) => {
    const token = await getAccessToken("enroll");

    const res = await fetch(confirmURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        grant_type: "http://auth0.com/oauth/grant-type/mfa-otp",
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
        mfa_token: token,
        otp,
      }),
    });

    return res;
  };

  const enrollWithGuardian = async () => {
    const token = await getAccessToken("enroll");

    const res = await fetch(enrollURL, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        authenticator_types: ["oob"],
        oob_channels: ["auth0"],
      }),
    });

    return res;
  };

  return {
    enrollWithOTP,
    enrollWithGuardian,
    enrollWithSMS,
    enrollWithVoice,
    confirmOTP,
    confirmSMS,
    confirmVoice,
  };
}
